var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.912,
    height: 24.277,
    viewBox: "0 1 36.912 24.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 1677",
    transform: "translate(0 1)",
    clipPath: "url(\"#a\")"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.457 24.278C8.511 24.278.684 13.13.357 12.656L0 12.14l.357-.516C.684 11.15 8.51.001 18.457.001c9.944 0 17.771 11.15 18.099 11.623l.356.516-.356.516c-.328.474-8.155 11.622-18.099 11.622M2.224 12.14c1.641 2.155 8.386 10.328 16.233 10.328 7.845 0 14.59-8.173 16.231-10.328-1.641-2.155-8.386-10.33-16.231-10.33-7.847 0-14.592 8.175-16.233 10.33",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6711"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.254 6.163a5.855 5.855 0 0 0 0 11.71 5.855 5.855 0 0 0 5.853-5.856 5.853 5.853 0 0 0-5.853-5.854m0 9.274a3.421 3.421 0 1 1-.001-6.843 3.421 3.421 0 0 1 .001 6.843",
    fillRule: "evenodd",
    "data-name": "Trac\\xE9 6712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h36.912v24.277H0V0z",
    "data-name": "Rectangle 1483"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.69d723af148dc34109114ff8dda13db5.svg";
export { ForwardRef as ReactComponent };